// import { RequestService } from '../../../../../common/services/RequestService';
// import { GET_ALL_ORDERS } from '../constants';
// import { dataAdjustmentResponse } from '../orders/dataAdjustment';

// import HARDCODE_History from '../../../common/hardCodeData/crm'; // todo подключить АПИ
import jsonToFormData from '../../../../../common/utils/jsonToFormData';

// todo hardcode
export const mailSendRequest = async (profileId, formData) => {
  console.log('mailSend', {
    profile: profileId,
    params: formData,
  });
  console.log(jsonToFormData(formData));
  return {
    recipient: formData.recipient.join(', '),
    data: {
      key: Date.now(),
      type: {
        title: 'Письмо на e-mail',
        description: formData.recipient.join(', '),
      },
      date_send: Date.now(),
      info: {
        text: formData.theme,
        description: '',
      },
    },
  };
  /*
  const response = await RequestService.get(
    GET_ALL_ORDERS.replace('{profile_id}', profileId)
  );
  return (
    response.data &&
    Array.isArray(response.data) &&
    response.data.map(order => dataAdjustmentResponse(order))
  );
  */
};
